import * as tslib_1 from "tslib";
import { OnInit, ElementRef, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FrontendRouteService } from '../frontend-route.service';
import { BaseComponent } from '../../core/components/bases/base-component';
import { AgmMap } from '@agm/core';
export class VideoDetailComponent extends BaseComponent {
    constructor(_changeDetectorRef, frontendRoute, plantingSiteArea) {
        super();
        this._changeDetectorRef = _changeDetectorRef;
        this.frontendRoute = frontendRoute;
        this.plantingSiteArea = plantingSiteArea;
        this.pinUrl = '/assets/img/map-icons/photo-pin-s.png';
        this.focusedPinUrl = '/assets/img/map-icons/photo-pin-focus.png';
        this.availableIcon = 'assets/img/map-icons/map-m-green.png';
        this.notAvailableIcon = 'assets/img/map-icons/map-m-red.png';
        this.labelBar = 'assets/img/map-icons/bar-label.png';
        this.nowDate = new Date().getTime();
        this.mapTypeId = 'hybrid';
        this.onResize = () => {
            this.videoWidth = this.youTubePlayer.nativeElement.clientWidth;
            this.videoHeight = this.youTubePlayer.nativeElement.clientHeight;
            this._changeDetectorRef.detectChanges();
        };
    }
    ngOnInit() {
        this.frontendRoute.currentSite$.subscribe(s => this.site = s);
        this.frontendRoute.currentPlantingSiteArea$.subscribe(c => this.siteArea = c);
        this.frontendRoute.currentVideo$.subscribe(v => this.video = v);
        this.getFlightPathData();
        window.addEventListener('resize', this.onResize);
        this.onResize();
    }
    ngAfterViewInit() {
        this.onResize();
    }
    ngOnDestroy() {
        window.removeEventListener('resize', this.onResize);
    }
    getYoutubeId() {
        const code = this.video.videoUrl.replace('https://www.youtube.com/watch?v=', '').replace('https://youtu.be/', '');
        return code;
    }
    getFlightPathData() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const anyFlightPathFromThisSite = this.siteArea.id;
            yield this.plantingSiteArea.getFlightPathData(anyFlightPathFromThisSite).then((value) => {
                this.allFlightPath = value;
            });
        });
    }
}
